import { setup, metrics } from '@seek/metrics-js';
import { detect } from 'detect-browser';

import type { Environment, FormName, PageName, CaptchaEvent } from '../types';

const prefix = 'online_identity_hosted_pages';

const getHost = (environment: Environment) =>
  `https://identity-metrics${
    environment === 'production' ? '' : '.staging'
  }.cloud.seek.com.au`;

interface CreateOptions {
  isEnabled: boolean;
  environment: Environment;
}

const toTags = (tags: Record<string, any>): string[] =>
  Object.keys(tags).map((key) => `${key}:${tags[key]}`);

export const setupMetrics = ({
  isEnabled = true,
  environment,
}: CreateOptions) => {
  const { name: browser, os } = detect() || {};
  const { hostname } = window.location;
  const globalTags = toTags({
    hostname,
    browser,
    os,
  });
  const host = getHost(environment);
  setup({ host, isEnabled, prefix, globalTags });
};

export const pageLoaded = (pageName: PageName) => {
  metrics.count('page_loaded', [`page:${pageName}`]);
};

export const formLoaded = (formName: FormName) => {
  metrics.count('form_loaded', [`form:${formName}`]);
};

export const captchaEvent = (event: CaptchaEvent) => {
  metrics.count('captcha_event', [`event:${event}`]);
};

export const emitAbTestMetric = (name: string, tags: string[] = []) => {
  metrics.count(name, tags);
};

export const cookieMetric = (tags: string[] = []) => {
  metrics.count('cookie_metric', tags);
};
